import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCustomizeTask = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	fill: "none",
	viewBox: "0 0 24 24",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fill: "#fff",
		fillRule: "evenodd",
		d: "m13 2.586-9 9v5.415h5.414l8.995-8.994L13 2.586zM6 15v-2.586l7-6.999 2.582 2.59L8.586 15H6z",
		clipRule: "evenodd"
	}), /* @__PURE__ */ _jsx("path", {
		fill: "#fff",
		d: "M4 20h16v-2H4v2z"
	})]
});
export default SvgCustomizeTask;
